<template>
    <div class="mx-auto container container--fluid">

        <v-snackbar v-model="snackbar" top :color="color" timeout="6000">
            {{ snackbar_msg }}
            <v-btn text dark @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box pa-4">
            <h3 class="section-title mb-3">Review No Dues</h3>

            <v-row class="mt-2" justify="center" dense>
                <v-col cols="auto" class="pa-1">
                    <div class="d-flex align-center">
                        <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                        <v-autocomplete id="userSelect1" label="Select User Type" v-model="selected_user_type"
                            :items="user_types" item-text="name" item-value="id" outlined required dense
                            style="max-width: 200px; margin:0;" />
                    </div>
                </v-col>

                <v-col cols="auto" class="pa-1">
                    <div class="d-flex align-center">
                        <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                        <v-autocomplete id="userSelect2" label="Select Clearance Status"
                            v-model="selected_clearance_status" :items="clearanceStatusWithAll" item-text="name"
                            item-value="id" outlined required dense style="max-width: 250px; margin:0;" />
                    </div>
                </v-col>

                <v-col cols="auto" class="pa-1">
                    <div class="d-flex align-center">
                        <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                        <v-autocomplete id="userSelect3" label="Student/Employee" v-model="request_id"
                            :items="usersWithAll" item-text="users_name" item-value="id" outlined required dense
                            style="max-width: 200px; margin:0;" />
                    </div>
                </v-col>
            </v-row>

            <v-row class="mb-4" justify="center">
                <v-checkbox v-model="datewise" label="Do you want datewise?" dense />
            </v-row>

            <v-row justify="center" align="center" class="ma-0" v-if="datewise">
                <v-col cols="auto" class="pa-1">
                    <div class="d-flex align-center">
                        <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                        <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" v-on="on" v-model="from_date" label="From Date" readonly
                                    outlined append-icon="mdi-calendar" dense style="max-width: 150px; margin:0;" />
                            </template>
                            <v-date-picker v-model="from_date" @input="menu1 = false" />
                        </v-menu>
                    </div>
                </v-col>

                <v-col cols="auto" class="pa-1">
                    <div class="d-flex align-center">
                        <v-icon color="error" size="small" class="mr-1 mb-12 ml-2">*</v-icon>
                        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" v-on="on" v-model="to_date" label="To Date" readonly
                                    outlined append-icon="mdi-calendar" dense style="max-width: 150px; margin:0;" />
                            </template>
                            <v-date-picker v-model="to_date" @input="menu2 = false" />
                        </v-menu>
                    </div>
                </v-col>
            </v-row>

            <v-row justify="center" class="mt-0 mb-0">
                <v-col cols="auto" class="pa-0">
                    <v-btn class="primary" @click="onFetch()">
                        Fetch
                    </v-btn>
                </v-col>
            </v-row>

            <v-row dense class="mt-2 mb-2" align="center" v-if="fetched">
                <v-col cols="auto">
                    <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                        <v-icon left color="success">mdi-export</v-icon>
                        Export
                    </v-btn>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="auto">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" hide-details
                        style="width: 500px" dense />
                </v-col>
                <v-spacer></v-spacer>
            </v-row>


            <v-data-table :headers="headers" :items="all_data" dense class="elevation-1 mytable center-header"
                :search="search" :item-key="'id'" v-if="fetched">

                <template v-slot:item.srno="{ item }">
                    {{ all_data.indexOf(item) + 1 }}
                </template>

                <template #item.request_date="{ item }">
                    <span>
                        {{ item.request_date ? formatDate(item.request_date) : "-" }}
                    </span>
                </template>

                <template #item.action="{ item }">
                    <v-btn class="primary" small @click="onProceed(item)">Proceed</v-btn>
                </template>

                <template v-slot:item.reason="{ item }">
                    <v-icon v-if="item.reason" color="primary" size="18" class="cursor-pointer"
                        @click="selectedRemark = item.reason; dialog_reason = true">
                        mdi-eye
                    </v-icon>
                    <span v-else>-</span>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog_reason" max-width="400">
            <v-card>
                <v-card-title>Reason</v-card-title>
                <v-card-text>
                    {{ selectedRemark }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="dialog_reason = false">OK</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog v-model="proceedDialog" width="100%" max-width="1200px" persistent class="proceed-dialog">
            <v-card class="rounded-lg pa-0" style="width: 100%;">
                <v-card-title class="heading-title d-flex align-center pa-2">
                    <span class="text-h6 font-weight-medium">
                        Review No Dues
                    </span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="closeProceedDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <!-- <v-card-text v-if="selectedRow" class="pa-4 user-info-box mt-2">
                    <div class="d-flex align-center mb-4">
                        <span class="text-subtitle-1 font-weight-medium">
                            User Information
                        </span>
                    </div>

                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field :label="selectedRow.usertype !== 'Student' ? 'Employee Code' : 'PRN'"
                                :value="selectedRow.employee_code" readonly dense outlined class="proceed-dialog" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Name" :value="selectedRow.person_name" readonly dense outlined
                                  class="proceed-dialog" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Contact No." :value="selectedRow.contact_no || 'Contact Not Present'"
                                readonly dense outlined  class="proceed-dialog"/>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Email" :value="selectedRow.email_id || 'Email Not Present'" readonly
                                dense outlined  class="proceed-dialog" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                :label="selectedRow.usertype !== 'Student' ? 'Date Of Joining' : 'Admission Date'"
                                :value="formatDate(selectedRow.date_of_joining)" readonly dense outlined 
                                class="proceed-dialog"/>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                :label="selectedRow.usertype !== 'Student' ? 'Last Working Date' : 'Last Day In Institute'"
                                :value="formatDate(selectedRow.last_working_date)" readonly dense outlined 
                                class="proceed-dialog"/>
                        </v-col>

                        <template v-if="selectedRow.usertype === 'Employee'">
                            <v-col cols="12" md="6">
                                <v-text-field label="Designation" :value="selectedRow.designation" readonly dense
                                    outlined 
                                    class="proceed-dialog"/>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field label="Employee Type" :value="selectedRow.employee_type" readonly dense
                                    outlined 
                                    class="proceed-dialog"/>
                            </v-col>
                        </template>

                        <template v-if="selectedRow.usertype === 'Student'">
                            <v-col cols="12" md="4">
                                <v-text-field label="Standard" :value="selectedRow.standard" readonly dense outlined 
                                  class="proceed-dialog"/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Division" :value="selectedRow.division" readonly dense outlined 
                                  class="proceed-dialog"/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Section" :value="selectedRow.section" readonly dense outlined 
                                  class="proceed-dialog"/>
                            </v-col>
                        </template>

                        <v-col cols="12">
                            <v-textarea label="Reason" :value="selectedRow.reason" readonly dense outlined rows="2" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Request Date" :value="formatDate(selectedRow.request_date)" readonly
                                dense outlined 
                                class="proceed-dialog"/>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Final Clearance Status"
                                :value="selectedRow.final_clearance_status_name" readonly dense outlined 
                                class="proceed-dialog"/>
                        </v-col>
                    </v-row>
                </v-card-text> -->
                <v-card-text v-if="selectedRow" class="pa-4 user-info-box mt-2">
                <div class="d-flex align-center mb-4">
                    <span class="text-subtitle-1 font-weight-medium">
                    User Information
                    </span>
                </div>

                <v-row dense>
                    <v-col cols="12" md="6">
                    <label class="field-label">{{ selectedRow.usertype !== 'Student' ? 'Employee Code' : 'PRN' }}</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.employee_code }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">Name</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.person_name }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">Contact No.</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.contact_no || 'Contact Not Present' }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">Email</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.email_id || 'Email Not Present' }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">{{ selectedRow.usertype !== 'Student' ? 'Date Of Joining' : 'Admission Date' }}</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ formatDate(selectedRow.date_of_joining) }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">{{ selectedRow.usertype !== 'Student' ? 'Last Working Date' : 'Last Day In Institute' }}</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ formatDate(selectedRow.last_working_date) }}
                    </v-sheet>
                    </v-col>

                    <template v-if="selectedRow.usertype === 'Employee'">
                    <v-col cols="12" md="6">
                        <label class="field-label">Designation</label>
                        <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.designation }}
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6">
                        <label class="field-label">Employee Type</label>
                        <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.employee_type }}
                        </v-sheet>
                    </v-col>
                    </template>

                    <template v-if="selectedRow.usertype === 'Student'">
                    <v-col cols="12" md="4">
                        <label class="field-label">Standard</label>
                        <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.standard }}
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <label class="field-label">Division</label>
                        <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.division }}
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <label class="field-label">Section</label>
                        <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.section }}
                        </v-sheet>
                    </v-col>
                    </template>

                    <v-col cols="12">
                    <label class="field-label">Reason</label>
                    <v-sheet class="read-only-field pa-2" style="min-height: 64px;">
                        {{ selectedRow.reason }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">Request Date</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ formatDate(selectedRow.request_date) }}
                    </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                    <label class="field-label">Final Clearance Status</label>
                    <v-sheet class="read-only-field pa-2">
                        {{ selectedRow.final_clearance_status_name }}
                    </v-sheet>
                    </v-col>
                </v-row>
                </v-card-text>

                


                <v-data-table :headers="user_data_headers" :items="clearance_dept_data" dense
                    class="elevation-1 mytable center-header mt-4" :search="search" :item-key="'id'">

                    <template v-slot:top>
                        <v-toolbar flat dense>
                            <h3 class="section-title mb-3">Clearance Flow</h3>
                            <v-spacer></v-spacer>
                            <v-row v-if="fetched" align="center">

                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense hide-details
                            clearable style="max-width: 450px" />
                    </v-col>

                      <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="3" class="d-flex justify-end">
                        <v-btn rounded color="success" outlined :loading="loader" :disabled="!all_data.length"
                            @click="downloadFile_flow">
                            <v-icon left>mdi-export</v-icon>
                            Export
                        </v-btn>

                    </v-col>
                </v-row>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.srno="{ item }">
                        {{ clearance_dept_data.indexOf(item) + 1 }}
                    </template>

                    <template v-slot:item.is_last_approving="{ item }">
                        <v-icon :color="item.is_last_approving ? 'green' : 'red'">
                            {{ item.is_last_approving ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                    </template>

                    <template #item.action_date="{ item }">
                        <span>
                            {{ item.action_date ? formatDate(item.action_date) : "-" }}
                        </span>
                    </template>

                    <template v-slot:item.responsible_person="{ item }">
                        <div class="d-flex align-center justify-center">
                            <span v-if="item.showInstructorName">
                                {{ item.responsible_person }}
                            </span>
                            <v-icon small class="ml-1 cursor-pointer" v-if="item.showInstructorName"
                                @click="hideInstructorName(item)">
                                mdi-close
                            </v-icon>

                            <v-icon :color="item.responsible_person ? 'blue' : 'grey'" class="cursor-pointer" v-else
                                @click="revealInstructorName(item)">
                                mdi-eye
                            </v-icon>
                        </div>
                    </template>

                    <template v-slot:item.remark="{ item }">
                        <v-icon color="blue" style="cursor: pointer" v-if="item.remark"
                            @click="selectedRemark = item.remark; dialog_remark = true">
                            mdi-eye
                        </v-icon>
                        <span v-else>-</span>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <div>
                           <v-btn v-if="item.allow === 'true' && 
                                        item.clearance_status != 'Approved' " icon size="x-small" @click="editAction(item)">
                            <v-icon small>mdi-pencil</v-icon>
                           </v-btn>
                        </div>
                    </template>

                </v-data-table>
                <v-dialog v-model="dialog_remark" max-width="400">
                <v-card>
                    <v-card-title>Remark</v-card-title>
                    <v-card-text>
                        {{ selectedRemark }}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="dialog_remark = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            </v-card>

        </v-dialog>

        <v-dialog v-model="actionDialog" max-width="500px" persistent>
            <v-card>

                <v-card-title class="heading-title d-flex align-center pa-2">
                    <span class="text-h6 font-weight-medium">
                        Edit Request Status
                    </span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="actionDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-1 pb-0 d-flex justify-center">
                    <div style="width: 100%;">
                        <v-row dense justify="center">

                            <v-col cols="12">
                                <v-textarea label="Enter Remark" v-model="remark" rows="3" outlined dense counter />
                            </v-col>

                            <v-col cols="12" class="d-flex justify-center">
                                <div class="d-flex align-center" style="width: 60%;">
                                    <v-icon color="error" small class="mr-1 mb-12">*</v-icon>

                                    <v-autocomplete label="Select Clearance Status" v-model="selected_status"
                                        :items="status_list" item-text="name" item-value="id" outlined dense required
                                        class="flex-grow-1" />
                                </div>
                            </v-col>

                        </v-row>
                    </div>
                </v-card-text>

                <v-card-actions class="justify-center pt-0 pb-2">
                    <v-btn outlined class="mr-3 px-6" @click="actionDialog = false;">
                        Cancel
                    </v-btn>

                    <v-btn color="primary" class="px-8" @click="editTransactionStatus(selectedItem)">
                        Save
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>


    </div>
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
export default {
    data: () => ({
        overlay: false,
        snackbar: false,
        snackbar_msg: "",
        color: "",
        search: "",
        dialog: false,
        menu1: false,
        menu2: false,
        from_date: "",
        to_date: "",
        datewise: false,
        fetched: false,
        selected_user_type: null,
        selected_clearance_status: null,
        headers: [
            { text: "S.No", value: "srno" },
            { text: "User Type", value: "usertype" }
        ],
        proceedDialog: false,
        selectedRow: null,
        dialog_reason: false,
        selectedRemark: "",
        actionDialog: false,
        dialog_remark:false,
        remark:"",
        selected_status:"",
        selectedItem:"",

        user_data_headers: [
            { text: "S.No", value: "srno", class: "text-center" },
            { text: "User Type", value: "usertype", class: "text-center" },
            { text: "Department", value: "dept_name", align: "center", class: "text-center" },
            { text: "Responsible Person", value: "responsible_person", align: "center", class: "text-center" },
            { text: "Level", value: "level", align: "center", class: "text-center" },
            { text: "Is Last Approving", value: "is_last_approving", align: "center", class: "text-center" },
            { text: "Action By", value: "action_by", align: "center", class: "text-center" },
            { text: "Action Date", value: "action_date", align: "center", class: "text-center" },
            { text: "Clearance Status", value: "clearance_status", align: "center", class: "text-center" },
            { text: "Remark", value: "remark", align: "center", class: "text-center" },
            { text: "Action", value: "action", align: "center", class: "text-center" },
        ],

        user_types: [],
        users_list: [],
        status_list: [],
        all_data: [],
        request_id: "",
        clearance_dept_data: [],
    }),
    watch: {
        dialog(val) {
            val || this.close();
        },

        actionDialog(val) {
            if (!val) {
            this.resetActionDialog()
            }
        },

        datewise(val){
            if(!val){
                this.from_date = "",
                this.to_date=""
            }
        }
    },

    mounted() {
        this.onLoad();
        this.getClearanceStatus();
        this.getUserList();
    },

    computed: {
        clearanceStatusWithAll() {
            return [
                { id: "ALL", name: "All" },
                ...this.status_list
            ]
        },

        usersWithAll() {
            return [
                { id: "ALL", users_name: "All" },
                ...this.filtered_users_list
            ]
        },

        allClearanceStatusIds() {
            return this.status_list.map(s => s.id)
        },

        allRequestIds() {
            // return this.filtered_users_list.map(u => u.id)
            return this.filtered_users_list
            .flatMap(u => u.id || [])
        },

        userTypeName() {
            const ut = this.user_types.find(u => u.id === this.selected_user_type)
            return ut.name || ""
        },

        filtered_users_list() {
            if (!this.selected_user_type || !this.user_types.length) return []

            const ut = this.user_types.find(
                u => u.id === this.selected_user_type
            )

            if (!ut) return []

            return this.users_list.filter(
                user => user.user_type === ut.name
            )
        },
    },

    methods: {
        showSnackbar(color, msg) {
            this.color = color;
            this.snackbar_msg = msg;
            this.snackbar = true;
        },
        close() {
            this.dialog = false;
            this.transaction_dialog = false;
            this.menu = false;
        },

        editItem(item) { 
            this.editedIndex = -1;
            this.dialog = true;
        },

        onFetch() {
            this.updateHeaders();
            this.getNoDuesData();
        },
        
        closeProceedDialog() {
            this.proceedDialog = false
            this.getNoDuesData()
        },
        
        onProceed(item) {
            this.selectedRow = { ...item }   // clone row data
            this.getClearanceData(item)
            this.proceedDialog = true

        },

        resetActionDialog() {
            this.remark = ""
            this.selected_status = null
        },

        Title_one() {
            return this.selected_user_type === "Employee" ? "Employee_code" : "PRN";
        },

        //show responsible person name
        revealInstructorName(item) {
            if (item.responsible_person) {
                this.$set(item, 'showInstructorName', true);
            }
        },

        //hide responsible person name
        hideInstructorName(item) {
            this.$set(item, 'showInstructorName', false);
        },

        //dynamically add or remove table headers based on selected user type
        updateHeaders() {
            let headers = [
                { text: "S.No", value: "srno" },
                { text: "User Type", value: "usertype" }
            ];

            const ut = this.user_types.find(u => u.id === this.selected_user_type);
            const userTypeName = ut ? ut.name : "";

            if (userTypeName === "Employee") {
                headers.push(
                    { text: "Employee", value: "person_name", align: "center" },
                    { text: "Designation", value: "designation", align: "center" },
                    { text: "Employee Type", value: "employee_type", align: "center" }
                );
            } else if (userTypeName === "Student") {
                headers.push(
                    { text: "Student", value: "person_name", align: "center" },
                    { text: "Standard", value: "standard", align: "center" },
                    { text: "Division", value: "division", align: "center" }
                );
            }

            headers.push(
                { text: "Section", value: "section", align: "center" },
                { text: "Request Date", value: "request_date", align: "center" },
                { text: "Reason", value: "reason", align: "center" },
                { text: "Final Clearance Status", value: "final_clearance_status_name", align: "center" },
                { text: "Action", value: "action", align: "center" }
            );

            this.headers = headers;
        },

        editAction(item) {
            this.selectedItem = item
            this.actionDialog = true;
        },

        onLoad() {
            this.overlay = true;
            axios
                .post("/Dues/getUserTypes")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.user_types = res.data.user_types;
                    } else {
                        this.snackbar("#4caf50", "Something went wrong!")
                    }

                })
                .catch((error) => {
                    window.console.log(error);
                })
        },

        getUserList() {
            this.overlay = true;
            axios
                .post("/Dues/getUsersList")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.users_list = res.data.users_list;
                    } else {
                        this.snackbar("#4caf50", "Something went wrong!")
                    }

                })
                .catch((error) => {
                    window.console.log(error);
                })
        },

        getClearanceData(item) {
            this.overlay = true;

            const payload = {
                user_req_id: item.id,
                usertype_id: item.usertype_id
            }
            axios.post("/Dues/getClearanceDataOfUser", payload)
                .then(res => {
                    this.overlay = false;
                    if (res.data.msg === "200") {
                        this.clearance_dept_data = res.data.clearance_dept_data;
                    }
                });
        },

        getClearanceStatus() {
            this.overlay = true;
            axios
                .post("/Dues/getStatus")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.status_list = res.data.clearance_status_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getNoDuesData() {
            if (this.selected_user_type && this.selected_clearance_status && this.request_id) {

                const payload = {
                    usertype: this.selected_user_type,

                    status: this.selected_clearance_status === "ALL" ? this.allClearanceStatusIds : [this.selected_clearance_status],
                    request_id: this.request_id === "ALL" ? this.allRequestIds : this.request_id,

                    fromDate: this.from_date,
                    toDate: this.to_date
                }
                axios.post("/Dues/getNoDuesData", payload)
                    .then((res) => {
                        if (res.data.code === "SUCCESS") {
                            this.all_data = res.data.all_request_data

                            if (this.all_data.length > 0) {
                                this.fetched = true;
                            }

                        } else if(res.data.code == "FAIL"){
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    }).catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            } else {
                this.showSnackbar("#b71c1c", "Enter all mandatory fields...");
            }
        },

        editTransactionStatus(item){
            if(this.selected_status){
                const payload = {
                    id : item.id,
                    dept_id : item.dept_id,
                    dept_name : item.dept_name,
                    level : item.level,
                    usertype_id : item.usertype_id,
                    updated_clearance_status : this.selected_status,
                    remark : this.remark
                }
                axios.post("Dues/editTransactionStatus",payload)
                    .then((res) => {
                        if(res.data.code === "SUCCESS"){
                            this.showSnackbar("#4caf50", "Transaction Updated Successfully");                         
                            this.actionDialog = false
                            this.getClearanceData(this.selectedRow);
                            // this.getNoDuesData();
                        }else{
                            this.showSnackbar("#4caf50", res.data.msg);
                        }
                    })
                    .catch((error) => {
                            window.console.log(error);
                    })
                    .finally(() => {
                            this.overlay = false;
                    });
            }else{
                 this.showSnackbar("#b71c1c", "Select Clearance Status");
            }   
        },

        formatDate(dateStr) {
            if (!dateStr) return "Date not present";
            const d = new Date(dateStr);
            const year = d.getUTCFullYear();
            const month = String(d.getUTCMonth() + 1).padStart(2, "0");
            const day = String(d.getUTCDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

    downloadFile() {
        this.loader = true;

        const exportHeaders = this.headers.filter(
            h => h.value && h.value !== "action"
        );

        const excelData = this.all_data.map((row, index) => {
            const obj = {};

            exportHeaders.forEach(h => {
            if (h.value === "srno") {
                obj[h.text] = index + 1;
            } else {
                obj[h.text] = row[h.value] || "";

            }
            });

            return obj;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ReviewNoDues");

        XLSX.writeFile(workbook, "ReviewNoDues.xlsx");

        this.loader = false;
    },

    downloadFile_flow(){
     this.loader = true;
        const excelData = this.clearance_dept_data.map((item, index) => ({
            "S.No" : index+1,
            "Department":item.dept_name,
            "Responsible Person": item.responsible_person,
            "Level": item.level,
            "Is Last Approving": item.is_last_approving,
            "Action By": item.action_by,
            "Action Date":this.formatDate(item.action_date),
            "Clearance Status": item.clearance_status,
            "Remark": item.remark,
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ClearanceFlow");
        XLSX.writeFile(workbook, "ClearanceFlow.xlsx");

        this.loader = false;
    },
    },
};
</script>

<style scoped>
.section-title {
    font-weight: 600;
    color: #3f51b5;
}

.bordered-table th,
.bordered-table td {
    border: 1px solid #d0d0d0;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
}

.request-table {
    margin: 0 auto;
    max-width: 900px;
}

.mytable /deep/ thead th {
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    color: white !important;
    text-align: center;
}

.mytable ::v-deep tbody tr {
    min-height: 64px;
    /* row height */
    background-color: #f9f9f9;
    /* optional */
}

.mytable ::v-deep tbody td {
    padding-top: 16px;
    padding-bottom: 16px;
    align-items: center;
    /* vertical center content */
}

.bordered-table th {
    background: rgb(229, 124, 35);
    color: white !important;
}

.action-box {
    background: #ffffff;
}

.heading-title {
    background-color: #3f51b5;
    color: #ffffff;
    padding: 4px 8px 4px 16px;
    min-height: unset;
}

.heading-title .v-icon {
    color: #ffffff;
}


.read-only-field {
  background-color: #f5f5f5;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  color: #757575;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding-left: 8px;
}
.field-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #555;
  margin-bottom: 4px;
  display: block;
}
</style>
